import { createContext } from 'react';

export type Translation = {
	name: string;
	translation: string;
};
export const Translations = createContext<Translation[]>([]);
